/** @deprecated Use icons from icons-v2-generated instead. */
export const NaturalLanguageIcon = ({ className = 'w-12 h-12' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29 65V57.381C29 52.619 25 50.9048 25 43C25 32.5238 32.5238 25 43 25C51.4928 25 57.7824 31.259 59.8596 39.2104C60.8254 42.9076 61.6947 46.7105 63.7546 49.929L64.582 51.2218C65.6669 52.9171 64.5319 55.1543 62.5231 55.2798L60.6873 55.3945C59.7131 55.4554 58.9252 56.2106 58.823 57.1813L58.377 61.4187C58.1627 63.4545 56.446 65 54.399 65H49C45.6863 65 43 62.3137 43 59"
      stroke="#FFC008"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** @deprecated Use icons from icons-v2-generated instead. */
export const AutomatedDiagnosticsIcon = ({ className = 'w-12 h-12' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M50.4384 28.5759C50.4384 26.6193 48.826 25 46.8371 25H43.163C41.174 25 39.5617 26.6194 39.5617 28.5761C39.5617 30.0115 38.6302 31.292 37.3676 32.0116C36.1043 32.7316 34.5269 32.8736 33.2624 32.1555C31.5393 31.1768 29.3063 31.7407 28.3114 33.4358L26.4764 36.5625C25.4812 38.2583 26.1003 40.4429 27.8241 41.4219C29.0884 42.14 29.7547 43.5637 29.7547 45C29.7547 46.4362 29.0884 47.8599 27.824 48.578C26.1002 49.5571 25.4811 51.7418 26.4763 53.4376L28.3112 56.5642C29.3061 58.2593 31.5392 58.8232 33.2623 57.8445C34.5268 57.1263 36.1042 57.2683 37.3676 57.9884C38.6302 58.708 39.5617 59.9885 39.5617 61.424C39.5617 63.3806 41.174 65 43.163 65H46.8371C48.826 65 50.4384 63.3807 50.4384 61.4241C50.4384 59.9885 51.3699 58.708 52.6326 57.9883C53.8961 57.2682 55.4735 57.126 56.7381 57.8443C58.4611 58.8229 60.6939 58.2589 61.6887 56.5639L63.5237 53.4372C64.519 51.7413 63.8997 49.5565 62.1758 48.5774C60.9117 47.8594 60.2453 46.4359 60.2453 45C60.2453 43.564 60.9117 42.1405 62.1758 41.4225C63.8996 40.4434 64.5189 38.2587 63.5236 36.5629L61.6885 33.436C60.6937 31.741 58.461 31.1771 56.738 32.1557C55.4735 32.8739 53.8961 32.7318 52.6326 32.0117C51.3699 31.292 50.4384 30.0115 50.4384 28.5759Z"
      stroke="#FFC008"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.0001 45C51.0001 48.3137 48.3138 51 45.0001 51C41.6864 51 39.0001 48.3137 39.0001 45C39.0001 41.6863 41.6864 39 45.0001 39C48.3138 39 51.0001 41.6863 51.0001 45Z"
      stroke="#FFC008"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** @deprecated Use icons from icons-v2-generated instead. */
export const StatusUpdatesIcon = ({ className = 'w-100 h-100' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M59.0031 43V47.2634C59.0031 48.8258 59.6126 50.3267 60.702 51.4467L61.151 51.9083C63.0005 53.8099 61.6531 57 59.0004 57H29.006C26.3534 57 25.0059 53.81 26.8553 51.9084L27.3044 51.4467C28.3937 50.3266 29.0031 48.8259 29.0031 47.2635V40C29.0031 31.7157 35.7188 25 44.0031 25C44.9889 25 45.9525 25.0951 46.8852 25.2766M48 65H40M64 30C64 32.7614 61.7614 35 59 35C56.2386 35 54 32.7614 54 30C54 27.2386 56.2386 25 59 25C61.7614 25 64 27.2386 64 30Z"
      stroke="#FFC008"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** @deprecated Use icons from icons-v2-generated instead. */
export const SmartEscalationIcon = ({ className = 'w-12 h-12' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28 35V49L49 28M62 47V33L41 54"
      stroke="#FFC008"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** @deprecated Use icons from icons-v2-generated instead. */
export const ScriptGenerationIcon = ({ className = 'w-12 h-12' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27 39H63M55 55H47M35 46L39.5 50.5L35 55M57 63H33C29.6863 63 27 60.3137 27 57V33C27 29.6863 29.6863 27 33 27H57C60.3137 27 63 29.6863 63 33V57C63 60.3137 60.3137 63 57 63Z"
      stroke="#FFC008"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** @deprecated Use icons from icons-v2-generated instead. */
export const PatchPolicyIcon = ({ className = 'w-12 h-12' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32 53C29.2386 53 27 55.2386 27 58C27 60.7614 29.2386 63 32 63C34.7614 63 37 60.7614 37 58C37 55.2386 34.7614 53 32 53ZM32 53V37M32 37C34.7614 37 37 34.7614 37 32C37 29.2386 34.7614 27 32 27C29.2386 27 27 29.2386 27 32C27 34.7614 29.2386 37 32 37ZM58 53C55.2386 53 53 55.2386 53 58C53 60.7614 55.2386 63 58 63C60.7614 63 63 60.7614 63 58C63 55.2386 60.7614 53 58 53ZM58 53V38C58 34.6863 55.3137 32 52 32H45M45 32L50 27M45 32L50 37"
      stroke="#FFC008"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** @deprecated Use icons from icons-v2-generated instead. */
export const BulkOperationsIcon = ({ className = 'w-12 h-12' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M63 32H45M63 44H45M63 56H45M27 43L30 46L36 40M27 55L30 58L36 52M27 31L30 34L36 28"
      stroke="#FFC008"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** @deprecated Use icons from icons-v2-generated instead. */
export const AuditLoggingIcon = ({ className = 'w-12 h-12' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M52.5 26.5C52.2239 26.5 52 26.7239 52 27C52 27.2761 52.2239 27.5 52.5 27.5V26.5ZM37.5 27.5C37.7761 27.5 38 27.2761 38 27C38 26.7239 37.7761 26.5 37.5 26.5V27.5ZM39.3536 48.6464C39.1583 48.4512 38.8417 48.4512 38.6464 48.6464C38.4512 48.8417 38.4512 49.1583 38.6464 49.3536L39.3536 48.6464ZM43 53L42.6464 53.3536C42.8417 53.5488 43.1583 53.5488 43.3536 53.3536L43 53ZM52.3536 44.3536C52.5488 44.1583 52.5488 43.8417 52.3536 43.6464C52.1583 43.4512 51.8417 43.4512 51.6464 43.6464L52.3536 44.3536ZM61 33H60.5V59H61H61.5V33H61ZM55 65V64.5H35V65V65.5H55V65ZM29 59H29.5V33H29H28.5V59H29ZM52.5 27V27.5H55V27V26.5H52.5V27ZM35 27V27.5H37.5V27V26.5H35V27ZM35 65V64.5C31.9624 64.5 29.5 62.0376 29.5 59H29H28.5C28.5 62.5899 31.4101 65.5 35 65.5V65ZM61 59H60.5C60.5 62.0376 58.0376 64.5 55 64.5V65V65.5C58.5899 65.5 61.5 62.5899 61.5 59H61ZM61 33H61.5C61.5 29.4101 58.5899 26.5 55 26.5V27V27.5C58.0376 27.5 60.5 29.9624 60.5 33H61ZM29 33H29.5C29.5 29.9624 31.9624 27.5 35 27.5V27V26.5C31.4101 26.5 28.5 29.4101 28.5 33H29ZM41 25V25.5H49V25V24.5H41V25ZM53 29H52.5V31H53H53.5V29H53ZM52 32V31.5H38V32V32.5H52V32ZM37 31H37.5V29H37H36.5V31H37ZM38 32V31.5C37.7239 31.5 37.5 31.2761 37.5 31H37H36.5C36.5 31.8284 37.1716 32.5 38 32.5V32ZM53 31H52.5C52.5 31.2761 52.2761 31.5 52 31.5V32V32.5C52.8284 32.5 53.5 31.8284 53.5 31H53ZM49 25V25.5C50.933 25.5 52.5 27.067 52.5 29H53H53.5C53.5 26.5147 51.4853 24.5 49 24.5V25ZM41 25V24.5C38.5147 24.5 36.5 26.5147 36.5 29H37H37.5C37.5 27.067 39.067 25.5 41 25.5V25ZM39 49L38.6464 49.3536L42.6464 53.3536L43 53L43.3536 52.6464L39.3536 48.6464L39 49ZM43 53L43.3536 53.3536L52.3536 44.3536L52 44L51.6464 43.6464L42.6464 52.6464L43 53Z"
      fill="#FFC008"
    />
  </svg>
);
